<div class="flex between-spacer">
  <h3 class="titulo">Pago</h3>
  <button class="btn-volver" routerLink="/venta/opciones/menu">volver</button>
</div>

<div class="flex around-spacer">
  <button class="btn-producto" (click)="cuadroPagaCon()">EFECTIVO</button>
  <button class="btn-producto" (click)="transbank()">TRANSBANK</button>
</div>

<!-- Modal Opciones Productos-->
<div
  class="modal fade"
  id="modalPago"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modelTitleId"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-producto-contenido">
        <h2 class="nombre-producto">
          ESTA VENTA: $ {{ service.venta | number: "1.0-0" }}
        </h2>

        <form [formGroup]="provForm" class="flex center-center mb-1">
          <div class="flex column-direction">
            <label>Paga con</label>

            <input
              class="input-producto-qty"
              type="text"
              formControlName="monto"
            />
          </div>
          <div class="flex column-direction">
            <label>Vuelto</label>

            <input
              class="input-producto-qty"
              type="text"
              formControlName="vuelto"
            />
          </div>
        </form>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('7')">7</button>
          <button class="btn-numero" (click)="agregarDigito('8')">8</button>
          <button class="btn-numero" (click)="agregarDigito('9')">9</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('4')">4</button>
          <button class="btn-numero" (click)="agregarDigito('5')">5</button>
          <button class="btn-numero" (click)="agregarDigito('6')">6</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('1')">1</button>
          <button class="btn-numero" (click)="agregarDigito('2')">2</button>
          <button class="btn-numero" (click)="agregarDigito('3')">3</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('0')">0</button>
          <button class="btn-numero" (click)="agregarDigito('00')">00</button>
          <button class="btn-numero" (click)="borrarDigito()">
            <i class="fas fa-backspace"></i>
          </button>
        </div>

        <div class="seccion-botones">
          <button class="btn-aceptar" (click)="pagaCon(39)">ACEPTAR</button>
          <button class="btn-eliminar" data-dismiss="modal">CANCELAR</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-backdrop *ngIf="cargando" [titulo]="msgBackdrop"></app-backdrop>
